export default __webpack_public_path__ + "img/upgrade_bg_1.png";